import React, { useContext, useRef, useState } from 'react';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { useQuery } from 'react-query';
import { FirebaseContext } from '../../context/FirebaseContext';
import LoadingAnimation from '../../components/LoadingAnimation';
import { useDropDowns } from '../../NecttosComp/APICaller/queryHooks';
import { getBookWithMember, getRenewBook } from '../../NecttosComp/APICaller/ApiServices';
import noPhotoAvailable from '../../static/images/library/noPhotoAvailable.png';
import noBookImageFount from '../../static/images/library/noBookImageFount.png';
import moment from 'moment';
import SearchableBookInput from '../../myComp/SearchableBookInput';
import { Body, Header, Main } from '../../NecttosComp/Layout/Layout';
import Input from '../../NecttosComp/Input/Input';
import Button from '../../NecttosComp/Button/Button';
import { Table, Thead, Th, Tbody, Tr, Td } from '../../NecttosComp/Table/Table';
import Instruction from '../../Documentation/Instruction';
import Input2 from '../../NecttosComp/Input/Input2';

function getDifferenceInDays(date1, date2) {
	const diffInMs = Math.abs(date2 - date1);
	return diffInMs / (1000 * 60 * 60 * 24);
}
export const RenewBook = ({ onClose }) => {
	const [loading, setLoading] = useState(false);

	const [state, setState] = React.useState({
		filterValue: '',
		page: 0,
	});

	const { collegeId, collegeList } = useContext(FirebaseContext);
	const componentRef = useRef();
	const selectedCollege = collegeList?.find((x) => x.collegeId === collegeId);
	const { data: bookWithMembers, refetch } = useQuery(['getBookWithMember', state?.bookStocksId], getBookWithMember(collegeId, state?.bookStocksId, state?.editedDate));
	const { data: activeBook, refetch: activeBookRefetch } = useQuery(['getRenewBook'], getRenewBook({ collegeId, state, setLoading }));
	const { data: dropDown } = useDropDowns('library');
	let bookMemberData = bookWithMembers?.bookDetails || {};
	let issuedData = activeBook?.issuedData || {};
	let returnDate = state?.editedDate ? new Date(state?.editedDate) : new Date();
	let tookDate = new Date(bookMemberData?.tookOn);
	let days = getDifferenceInDays(tookDate, returnDate).toFixed(0);
	let fine = 14 < parseInt(days) ? parseInt(days) - 14 : 0;

	const UpdateBookStatus = async (item) => {
		try {
			setLoading(true);
			let data = {
				bookId: item?.bookId,
				bookStocksId: item?.bookStocksId,
				collegeId,
				userId: bookMemberData?.userId,
				action: 'renew',
				status: 'renew',
				takenStatus: item.takenStatus,
				returnDate,
				days: item.days,
				fine: item.fine,
				bookDetails: state?.bookDetails || item?.bookDetails || '',
			};
			const instance = await getAxiosTokenInstance();
			const resp = await instance.post('/college/library/takeBook', data);
			setLoading(false);
			activeBookRefetch();
			refetch();
			bookWithMembers = {};
			return resp.data;
		} catch (err) {
			return new Error('Book not available');
		}
	};
	const truncateTitle = (title) => (title.length > 60 ? `${title.slice(0, 26)} ... ${title.slice(-26)}` : title);

	return (
		<Main width='100%' height='100%' title='Renew Register'>
			<Header className='flex items-center justify-between gap-2 flex-nowrap px-2 overflow-x-auto'>
				<div className='flex items-center gap-2 flex-nowrap'>
					<Button
						type='save'
						disabled={parseInt(state.page) < 1}
						onClick={() => {
							setState({ ...state, page: parseInt(state.page) - 1 });
						}}>
						Prev
					</Button>

					<Input2 className='w-[80px]' returnKey='page' fieldName='Pages' state={state} setState={setState} type='text' />

					<Button
						type='save'
						disabled={parseInt(state.page) * 30 > parseInt(activeBook?.total?.[0]?.total) - 30}
						onClick={() => {
							setState({ ...state, page: parseInt(state.page) + 1 });
						}}>
						Next
					</Button>

					<div className='inline-flex h-[40px] items-center justify-center px-2 bg-gray-100 dark:bg-gray-700 rounded-lg shadow text-sm font-medium text-gray-800 dark:text-white whitespace-nowrap'>
						<span>
							Showing&nbsp;
							<strong>{parseInt(state.page) * 30 + 1}</strong>
							&nbsp;-&nbsp;
							<strong>{parseInt(state.page) * 30 + 30}</strong>
							&nbsp;of&nbsp;
							<strong>{RenewBook?.total?.[0]?.total || 0}</strong>
						</span>
					</div>

					{/* <Input2 className='w-[200px]' returnKey='filterValue' fieldName='Search' state={state} setState={setState} type='text' placeholder='Search by title or acc no' /> */}
					<Input2 className='w-[150px]' returnKey='startDate' fieldName='Start Date' state={state} setState={setState} type='date' />

					<Input2 className='w-[150px]' returnKey='endDate' fieldName='End Date' state={state} setState={setState} type='date' />
				</div>

				<div className='flex items-center gap-2 flex-nowrap'>
					<Button type='fetch' onClick={activeBookRefetch}>
						Load
					</Button>
					<Button type='print' tableRef={componentRef.current}>
						Print
					</Button>
					<Instruction keyId='renewBook' />
					<Button type='close' onClick={onClose}>
						Close
					</Button>
				</div>
			</Header>

		<div className='mt-2 flex flex-wrap items-center gap-2'>
  <div className='w-[350px]'>
    <SearchableBookInput filter='renew' stateData={state} setStateData={setState} keyData='' titleData='Search Book' />
  </div>

  <Input2 className='w-[200px]' returnKey='editedDate' fieldName='Edit Return Date' state={state} setState={setState} type='text' />

  <Input2 className='w-[300px]' returnKey='editedReason' fieldName='Reason for Edit Return Date' state={state} setState={setState} type='text' />

  <div className='ml-auto flex gap-2'>
    <Button type='fetch' onClick={refetch}>
      Reload
    </Button>

    <Button
      type='close'
      onClick={() => {
        setState({
          filterValue: '',
          page: state.page,
          accessionNumber: '',
          bookId: '',
          bookStocksId: '',
          imageUrl: '',
          keyData: '',
          editedDate: '',
        });
        activeBookRefetch();
      }}>
      Clear
    </Button>
  </div>
</div>


			{state?.accessionNumber ? (
				<Body>
					{state?.accessionNumber && (
						<div className='flex flex-row bg-slate-100 dark:bg-gray-700'>
							<div className='flex  w-1/4 flex-col sm:flex-row gap-4 bg-slate-100 dark:bg-gray-800 m-3 rounded-lg'>
								<div className='flex flex-col   justify-center items-center w-[100%] '>
									<div className='flex flex-col gap-2   justify-center items-center'>
										<h5 className='text-xl font-bold text-slate-800 dark:text-slate-100'>{bookMemberData?.name}</h5>
										<div className='w-60 h-68 rounded-lg overflow-hidden border-2 border-gray-300 dark:border-gray-600'>
											<img
												src={bookMemberData?.photoURL || noPhotoAvailable}
												alt='User'
												className='w-full h-full object-cover'
												onError={(e) => {
													e.target.onerror = null;
													e.target.src = noPhotoAvailable;
												}}
											/>
										</div>
										<div className='flex flex-col gap-1'>
											<p className='text-slate-800 dark:text-slate-100'>{bookMemberData?.className}</p>
											<p className='text-slate-800 dark:text-slate-100'>Mn: {bookMemberData?.admisionNo}</p>
										</div>
									</div>
								</div>
							</div>
							<div className=' w-3/4 bg-slate-100 dark:bg-gray-800 rounded-lg m-3 h-[80vh] p-4 overflow-auto'>
								<div className='grid grid-cols-4 gap-2 '>
									{bookMemberData?.booksData?.map((item, i) => (
										<div key={i} className='bg-slate-100 dark:bg-gray-700 p-4 rounded-lg shadow-md flex flex-col gap-4 m-2'>
											<div className='flex items-center gap-4'>
												<img
													src={item.photoURL || noBookImageFount}
													alt='Book'
													className='w-16 h-16 object-cover rounded-lg border border-gray-300 dark:border-gray-600'
													onError={(e) => {
														e.target.onerror = null;
														e.target.src = noBookImageFount;
													}}
												/>
												<div className='flex flex-col gap-1'>
													<h2 className='text-lg font-semibold text-gray-900 dark:text-gray-100'>{item.accessionNumber}</h2>
													<h3 className='text-sm text-gray-600 dark:text-gray-300'>{item.callNo}</h3>
													<h3 className='text-sm text-gray-600 dark:text-gray-300'>Fine: {item.fine}</h3>
													<h3 className='text-sm text-gray-600 dark:text-gray-300'>
														Days: {item.days} ({item.holidaysReport}h)
													</h3>
												</div>
											</div>

											<h4 className='text-sm text-gray-700 dark:text-gray-200'>{truncateTitle(item?.nameOfBook || '--')}</h4>

											<h5 className='text-xs text-gray-500 dark:text-gray-400'>
												{moment(new Date(item.tookOn)).format('DD MMM YY')} [{item.takenStatus === 'renew' ? 'R' : 'I'}]
											</h5>

											{loading ? (
												<div className='flex justify-center py-2'>
													<LoadingAnimation customHeight={50} customWidth={50} />
												</div>
											) : (
												<Button type='save' disabled={!item?.eligibleForRenew || item.days < 2} onClick={() => UpdateBookStatus(item)}>
													Renew {item?.eligibleForRenew ? item?.renewDays : 0}D
												</Button>
											)}
										</div>
									))}
								</div>
							</div>
						</div>
					)}
					{!state?.accessionNumber && (
						<div className='bg-white dark:bg-gray-800 rounded-xl shadow-md p-4'>
							<h6 className='text-xl font-bold text-gray-800 dark:text-white'>{bookMemberData.takenStatus === 'renew' ? 'Book Renewed' : 'Book Issued'}</h6>
							<h6 className='text-lg text-gray-600 dark:text-gray-400'>{moment(new Date(tookDate)).format('DD MMM YYYY hh:mm A')}</h6>
							<div className='flex gap-4'>
								<Button className='bg-red-600 text-white py-2 px-4 rounded-md hover:bg-red-700' style={{ width: '90px' }} onClick={() => refetch()}>
									{days} Days
								</Button>
								<Button className='bg-red-600 text-white py-2 px-4 rounded-md hover:bg-red-700' style={{ width: '90px' }} onClick={() => UpdateBookStatus()}>
									Fine {fine}
								</Button>
							</div>

							<Input width='600px' returnKey='bookDetails' fieldName='Remarks' state={state} setState={setState} type='text' />

							<div className='mt-4 flex gap-4'>
								{state?.accessionNumber && (
									<Button type='reload' className=' py-2 px-4 rounded-md' onClick={() => refetch()}>
										Reload
									</Button>
								)}
								{state?.accessionNumber + '' === bookMemberData?.accessionNumber + '' && bookMemberData?.bookStocksId && bookMemberData?.bookId && bookMemberData?.userId && (
									<Button type='submit' disabled={!bookMemberData?.eligibleForRenew} className='py-2 px-4 rounded-md' onClick={() => UpdateBookStatus()}>
										Renew {bookMemberData?.renewDays}
									</Button>
								)}
							</div>
						</div>
					)}
				</Body>
			) : (
				<Body>
					<div ref={componentRef} className='printable bg-slate-100 dark:bg-neutral-800 rounded-lg mt-2 p-4 relative text-black'>
						<div className='w-full flex flex-col rounded-2xl p-4 text-[12px]'>
							<div className='w-full flex flex-row items-center mb-4'>
								<img src={selectedCollege?.logo} alt='Logo' className='w-[12%] h-auto' />
								<div className='w-full text-center'>
									<h1 className='text-[20px] dark:text-slate-100 font-bold'>{selectedCollege?.collegeShortName}</h1>
									<p className='text-[16px] dark:text-slate-100 font-semibold'>{selectedCollege?.accreditedGrade}</p>
									<p className='text-[10px] dark:text-slate-100 font-semibold'>
										{selectedCollege?.address}, Phone: {selectedCollege?.phoneNumber}
									</p>
								</div>
							</div>
							<Table width='100%' innerWidth={['10%', '10%', '32%', '16%', '9%', '5%', '5%', '10%', '10%', '15%', '15%']}>
								<Thead>
									<Tr>
										<Th position={0} textAlign='center'>
											Sn
										</Th>
										<Th position={1} textAlign='center'>
											Acc No
										</Th>
										<Th position={2}>Title</Th>
										<Th position={3}>Author</Th>
										<Th position={4} textAlign='center'>
											DateTime
										</Th>
										<Th position={5} textAlign='center'>
											Days
										</Th>
										<Th position={6} textAlign='center'>
											Fine
										</Th>
										<Th position={7} textAlign='center'>
											Mn No
										</Th>
										<Th position={8} textAlign='center'>
											Class/Dept.
										</Th>
										<Th position={9}>Mn Name</Th>
										<Th position={10}>Renewed By</Th>
									</Tr>
								</Thead>
								<Tbody height='65vh'>
									{issuedData?.data
										?.filter((item) => {
											if (!state.filterValue) return true;
											const val = state.filterValue.toLowerCase();
											return (item.title + '')?.toLowerCase().includes(val) || (item.accessionNumber + '')?.toLowerCase().includes(val) || (item.issuedTo + '')?.toLowerCase().includes(val);
										})

										?.map((item) => (
											<Tr key={item.sn}>
												<Td position={0} textAlign='center'>
													{item.sn}
												</Td>
												<Td position={1} textAlign='center'>
													{item.accessionNumber}
												</Td>
												<Td position={2}>{item.title}</Td>
												<Td position={3}>{item.author}</Td>
												<Td position={4} textAlign='center'>
													{moment(new Date(item?.tookOn)).format('DD MMM YYYY hh:mm A')}
												</Td>
												<Td position={5} textAlign='center'>
													{item.days}
												</Td>
												<Td position={6} textAlign='center'>
													{item.fine}
												</Td>
												<Td position={7} textAlign='center'>
													{item.admisionNo}
												</Td>
												<Td position={8} textAlign='center'>
													{item.className}
												</Td>
												<Td position={9}>{item.issuedTo}</Td>
												<Td position={10}>{item.issuedBy}</Td>
											</Tr>
										))}
								</Tbody>
							</Table>
							<p className='mt-4 text-right text-[10px] font-semibold text-gray-800 dark:text-white'>Seal & Signature: {moment(new Date()).format('DD MMM YYYY hh:mm A')}</p>
						</div>
					</div>
				</Body>
			)}
		</Main>
	);
};
